import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTabGroup} from "@angular/material/tabs";
import {Subscription} from "rxjs";
import {CompanyEvents} from "./company-events";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {AuthenticationService} from "../../services/authentication.service";
import {User} from "../../models/user";
import {Role} from "../../dip/role";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html'
})
export class CompanyComponent implements OnInit, OnDestroy {
  detailsTitle: string = this.translate.instant('company.details.title');
  batterySettingsTitle: string = this.translate.instant('company.battery_settings.title');
  companyEvent$: EventEmitter<CompanyEvents> = new EventEmitter<CompanyEvents>();
  companyEventSubscription: Subscription;
  user: User;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  constructor(public organizationTreeSelect: OrganizationTreeSelect, private authService: AuthenticationService, private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.companyEventSubscription = this.companyEvent$.subscribe(event => {
      switch (event) {
        case CompanyEvents.SITE_DBL_CLICK: {
          this.tabGroup.selectedIndex = 3;
        }
      }
    });
    this.user = this.authService.currentUserValue;
  }

  ngOnDestroy(): void {
    this.companyEventSubscription.unsubscribe();
  }

  isMember() {
    return this.user.roles.includes(Role.ROLE_SYS) || this.user.organizationStatus[this.organizationTreeSelect.company.id];
  }
}
